export const seriesSyncOptions: SelectorOption<number>[] = [
  { label: "15 Minutes", value: 15 },
  { label: "1 Hour", value: 60 },
  { label: "3 Hours", value: 180 },
  { label: "6 Hours", value: 360 },
  { label: "12 Hours", value: 720 },
  { label: "24 Hours", value: 1440 },
];

export const episodesSyncOptions = seriesSyncOptions;

export const moviesSyncOptions = seriesSyncOptions;

export const diskUpdateOptions: SelectorOption<string>[] = [
  { label: "Manually", value: "Manually" },
  { label: "Daily", value: "Daily" },
  { label: "Weekly", value: "Weekly" },
];

export const dayOptions: SelectorOption<number>[] = [
  { label: "Monday", value: 0 },
  { label: "Tuesday", value: 1 },
  { label: "Wednesday", value: 2 },
  { label: "Thursday", value: 3 },
  { label: "Friday", value: 4 },
  { label: "Saturday", value: 5 },
  { label: "Sunday", value: 6 },
];

export const upgradeOptions: SelectorOption<number>[] = [
  { label: "3 Hours", value: 3 },
  { label: "6 Hours", value: 6 },
  { label: "12 Hours", value: 12 },
  { label: "24 Hours", value: 24 },
];
